import exercisesAvatar from "@/assets/image/chat/exercises.svg"
import mexercisesAvatar from "@/assets/image/chat/mexercises.svg"
import pexercisesAvatar from "@/assets/image/chat/pexercises.svg"
import collectAvatar from "@/assets/image/chat/collect.svg"
import wrongAvatar from "@/assets/image/chat/wrong.svg"
import wallgAvatar from "@/assets/image/chat/wall.svg"
import compositionAvatar from "@/assets/image/chat/composition.svg"
import knowledgeAvatar from "@/assets/image/chat/knowledge.svg"
import levelAvatar from "@/assets/image/chat/level.svg"
import * as sendReceiveApi from "@/api/chat/sendReceiveApi"
import { ApiService } from "@/api/fetch/apiService"
import { getBaseURL } from "../../utils/request"
const baseURL = getBaseURL();
export default {

    exercises: {
        id: "exercises",
        name: "高中智能体",
        avatar: exercisesAvatar,
        startNewSession: sendReceiveApi.startNewSession,
        getStreamAnswer: ApiService.fetchMathData,
        answerUrl: `${baseURL}/MathChat`,
        level: 'h',
        greeting: "探数蚁—AI智学助手为您服务，已为您开启新会话",
    },
    mexercises: {
        id: "mexercises",
        name: "初中智能体",
        avatar: mexercisesAvatar,
        startNewSession: sendReceiveApi.startNewSession,
        getStreamAnswer: ApiService.fetchMathData,
        level: 'm',
        answerUrl: `${baseURL}/MathChat`,
        greeting: "探数蚁—AI智学助手为您服务，已为您开启新会话",
    },
    pexercises: {
        id: "pexercises",
        name: "小学智能体",
        avatar: pexercisesAvatar,
        startNewSession: sendReceiveApi.startNewSession,
        getStreamAnswer: ApiService.fetchMathData,
        level: 'p',
        answerUrl: `${baseURL}/MathChat`,
        greeting: "探数蚁—AI智学助手为您服务，已为您开启新会话",
        disableQuestionCollect: false,   // 禁用题目收藏
        disablePaperCollect: false,      // 禁用试卷收藏
    },
    composition: {
        id: "composition",
        name: "组卷智能体",
        avatar: compositionAvatar,
        startNewSession: sendReceiveApi.startNewSession,
        getStreamAnswer: ApiService.fetchPaperComposition,
        answerUrl: `${baseURL}/TestPaperComposition`,
    },
    knowledgeGraph: {
        id: "knowledgeGraph",
        name: "高中方法图谱",
        avatar: knowledgeAvatar,
        startNewSession: sendReceiveApi.startNewSession,
        getStreamAnswer: ApiService.fetchKnowledgeReport,
        answerUrl: `${baseURL}/ShowMethods`,
        isShow: 'no',
    },
    mathLevel: {
        id: "mathLevel",
        name: "我的数学水平",
        avatar: levelAvatar,
        startNewSession: sendReceiveApi.startNewSession,
        getStreamAnswer: ApiService.fetchMathData,
        answerUrl: `${baseURL}/ShowMethods`,
    },
    wrong: {
        id: "wrong",
        name: "我的错题本",
        avatar: wrongAvatar,
        startNewSession: sendReceiveApi.startNewSession,
        getStreamAnswer: ApiService.fetchMathData,
        answerUrl: `${baseURL}/MathChat`,
    },
    wall: {
        id: "wall",
        name: "我的知识墙",
        avatar: wallgAvatar,
        startNewSession: sendReceiveApi.startNewSession,
        getStreamAnswer: ApiService.fetchMathData,
        answerUrl: `${baseURL}/MathChat`,
    },
    collect: {
        id: "collect",
        name: "我的收藏本",
        avatar: collectAvatar,
        startNewSession: sendReceiveApi.startNewSession,
        getStreamAnswer: ApiService.fetchMathData,
        answerUrl: `${baseURL}/MathChat`,
    },
    questionCollect: {
        id: "questionCollect",
        name: "题目收藏",
        avatar: collectAvatar,
        startNewSession: sendReceiveApi.startNewSession,
        getStreamAnswer: ApiService.fetchMathData,
        answerUrl: `${baseURL}/MathChat`,
        isShow: "no"
    },
    paperCollect: {
        id: "paperCollect",
        name: "试卷收藏",
        avatar: collectAvatar,
        startNewSession: sendReceiveApi.startNewSession,
        getStreamAnswer: ApiService.handlePaper,
        answerUrl: `${baseURL}/TestPaperComposition`,
        isShow: "no"
    },
    graphCollect: {
        id: "graphCollect",
        name: "图谱收藏",
        avatar: collectAvatar,
        startNewSession: sendReceiveApi.startNewSession,
        getStreamAnswer: ApiService.fetchKnowledgeReport,
        answerUrl: `${baseURL}/kgNode2report`,
        isShow: "no"
    },
    topicCollect: {
        id: "topicCollect",
        name: "专题收藏",
        avatar: collectAvatar,
        startNewSession: sendReceiveApi.startNewSession,
        getStreamAnswer: ApiService.fetchMathData,
        answerUrl: `${baseURL}/showTopic`,
        isShow: "no"
    },

}